var CBJ_WISHLIST = 'cbj_wishlist';

function _wlGet() {
  try { return JSON.parse(localStorage.getItem(CBJ_WISHLIST)) || []; } catch(e) { return []; }
}

function _wlSave(list) {
  localStorage.setItem(CBJ_WISHLIST, JSON.stringify(list));
}

function _wlHas(url) {
  return _wlGet().some(function(i) { return i.url === url; });
}

function _wlRemove(url) {
  var list = _wlGet().filter(function(i) { return i.url !== url; });
  _wlSave(list);
  _wlUpdateUI();
  _wlRender();
}

function _wlToggle(url, title, price, img) {
  var list = _wlGet();
  var idx = -1;
  for (var i = 0; i < list.length; i++) { if (list[i].url === url) { idx = i; break; } }
  if (idx !== -1) { list.splice(idx, 1); } else { list.push({ url: url, title: title, price: price, img: img }); }
  _wlSave(list);
  _wlUpdateUI();
}

function _wlUpdateUI() {
  var list = _wlGet();
  var countEl = document.getElementById('wishlist-count');
  if (countEl) {
    countEl.textContent = list.length;
    countEl.style.display = list.length > 0 ? 'flex' : 'none';
  }
  var spBadge = document.getElementById('sp-wishlist-badge');
  if (spBadge) {
    spBadge.textContent = list.length;
    spBadge.style.display = list.length > 0 ? 'flex' : 'none';
  }
  document.querySelectorAll('.btn-wishlist').forEach(function(btn) {
    btn.classList.toggle('is-wishlisted', _wlHas(btn.dataset.url));
  });
}

function _wlRender() {
  var el = document.getElementById('wishlist-items');
  if (!el) return;
  var list = _wlGet();
  if (list.length === 0) {
    el.innerHTML = '<p style="padding:24px 0;color:#BCBAB8;text-align:center;font-size:12px">お気に入りはまだありません</p>';
    return;
  }
  el.innerHTML = list.map(function(item) {
    var escapedUrl = item.url.replace(/'/g, "\\'");
    return '<div style="display:flex;align-items:center;gap:12px;padding:12px 0;border-bottom:1px solid #E2E0DE">'
      + '<a href="' + item.url + '" style="display:flex;align-items:center;gap:12px;flex:1;text-decoration:none;color:inherit;min-width:0">'
      + (item.img ? '<img src="' + item.img + '" style="width:56px;height:56px;object-fit:cover;border-radius:4px;flex-shrink:0">' : '')
      + '<div style="min-width:0"><div style="font-size:14px;font-weight:500;margin-bottom:2px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">' + item.title + '</div>'
      + '<div style="font-size:13px;color:#888">' + item.price + '</div></div>'
      + '</a>'
      + '<button onclick="_wlRemove(\'' + escapedUrl + '\')" style="background:none;border:none;cursor:pointer;color:#BCBAB8;font-size:18px;padding:4px 8px;flex-shrink:0;line-height:1" title="削除">×</button>'
      + '</div>';
  }).join('');
}

function openWishlist() {
  var modal = document.getElementById('wishlistModal');
  if (!modal) return;
  if (modal.parentNode !== document.body) document.body.appendChild(modal);
  var hdr = document.querySelector('header');
  if (hdr) {
    modal.querySelector('.wishlist-modal-box').style.top = hdr.offsetHeight + 'px';
  }
  _wlRender();
  modal.classList.add('is-open');
  document.body.style.overflow = 'hidden';
}

function closeWishlist() {
  var modal = document.getElementById('wishlistModal');
  if (!modal) return;
  modal.classList.remove('is-open');
  document.body.style.overflow = '';
}

document.addEventListener('DOMContentLoaded', function() {
  _wlUpdateUI();
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeWishlist();
  });
});

document.addEventListener('click', function(e) {
  var btn = e.target.closest('.btn-wishlist');
  if (!btn) return;
  e.preventDefault();
  e.stopPropagation();
  _wlToggle(btn.dataset.url, btn.dataset.title, btn.dataset.price, btn.dataset.img);
});
